<template>
  <v-snackbar
    elevation="0"
    v-model="obtenerDatosAlerta.visibilidad"
    color="success"
    top
  >
    <v-icon>mdi-check</v-icon>
    {{ obtenerDatosAlerta.mensaje }}
  </v-snackbar>
</template>

<script>
import { setTimeout } from 'timers'
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      obtenerDatosAlerta: 'alerta/obtenerDatosAlertaExito',
    }),
  },
  watch: {
    obtenerDatosAlerta: {
      handler(value) {
        if (value) {
          var v = this
          setTimeout(() => {
            v.cerrar()
          }, this.obtenerDatosAlerta.tiempo)
        }
      },
      deep: true,
    },
  },
  methods: {
    cerrar() {
      this.restablecerAlerta()
    },
    ...mapActions({
      restablecerAlerta: 'alerta/restablecerAlertaExito',
    }),
  },
}
</script>

<style></style>
